interface IMaskHandler {
    mask: string
    value: string
    validation: (state:boolean) => void
}

const maskHandler = (props:IMaskHandler):string => {
    const {mask, value, validation}:IMaskHandler = props

    let index:number = 0
    const result:string[] = []
    const defaultValue:string = value.replace(/[^0-9]/g, '')

    mask.split('').map((char:string) => {
        if (index === defaultValue.length) return
        if (char === '#') {
            result.push(defaultValue.split('')[index])
            index++
        } else result.push(char)
        validation(result.join('').length === mask.length)
    })

    return result.join('')
}

export default maskHandler
